import { SVGProps } from 'react';
const SvgListCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 17h7M20 14l-4 4-2-2M4 12h11M4 7h11"
    />
  </svg>
);
export default SvgListCheck;
